export default function useShopper() {
  const nuxtApp = useNuxtApp()
  const locale = nuxtApp.$i18n.locale.value
  const clients = nuxtApp.$commerce.getClientsForLocale(locale)

  async function getAuthHeaders() {
    const { getAccessToken, error } = useRefreshTokens()
    const accessToken = await getAccessToken()
    if (!accessToken) {
      throw new Error(error.value?.message)
    }

    const headers = {
      Authorization: `Bearer ${accessToken}`,
    }
    return headers
  }

  return {
    getAuthHeaders,
    ...clients,
    helpers: nuxtApp.$commerce.helpers,
  }
}
